import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'app-formly-message',
  styles: [`
  .bloc-form-content{ padding: 8px 16px !important;}
  mat-icon{ margin-right:10px;}
  `],
  template: `
    <div [ngClass]="{'bloc-form border': field.templateOptions.borderVisible===true}">
      <div class="bloc-form-title-bar" *ngIf="(field.templateOptions.displayTitle && field.templateOptions.label && field.templateOptions.label !== '')">
        <mat-icon>{{ (field.templateOptions.icon) ? field.templateOptions.icon : 'chevron_right'}}</mat-icon>
        <span>{{ field.templateOptions.label }}</span>
      </div>
      <div class="bloc-form-content" [ngClass]="{'no-padding': field.templateOptions.nopadding===true}">
        <div *ngIf="field.templateOptions.message" [innerHTML]="field.templateOptions.message | safe"></div>
      </div>
    </div>
  `
})

export class FormMessageComponent extends FieldType {
}
